import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { mainModule } from './main';
import { State } from './state';
import { adminModule } from './admin';
import { coursesModule } from './courses';
import { teamModule } from './team';
import { contactsModule } from './contacts';
import { flowsModule } from './user_flows';
import { eventsModule } from './events';
import { dashboardModule } from './dashboard';
import { subscriptionModule } from './subscription';
import { newsModule } from './news';
import { staffModule } from './staff';
import { userTasksModule } from './user_tasks';

Vue.use(Vuex);

const storeOptions: StoreOptions<State> = {
  modules: {
    main: mainModule,
    admin: adminModule,
    courses: coursesModule,
    team: teamModule,
    contacts: contactsModule,
    flows: flowsModule,
    events: eventsModule,
    dashboard: dashboardModule,
    subscription: subscriptionModule,
    news: newsModule,
    staff: staffModule,
    userTasks: userTasksModule,
  },
};

export const store = new Vuex.Store<State>(storeOptions);

export default store;
